const sliderSections = document.querySelectorAll(".slider-section");
sliderSections.forEach((sliderSection, i) => {
  const slider = tns({
    container: sliderSection.querySelector(".slider"),
    items: 1,
    // center: true,
    autoplay: true,
    controls: true,
    nav: false,
    //navContainer: sliderSection.querySelector('.team-slider-nav'),
    loop: true,
    autoplayButtonOutput: false,
    controlsContainer: sliderSection.querySelector(".slider-controls"),
    speed: 400,
    gutter: 12,
    fixedHeight: true,
    responsive: {
      768: {
        items: 2,
        gutter: 30,
      },
      1024: {
        items: 2,
        gutter: 30,
      },
      1200: {
        items: 3,
        gutter: 24,
      },
    },
    
  });
});